import(/* webpackMode: "eager", webpackExports: ["WidgetTemplates"] */ "/vercel/path0/src/components/widgetTemplates/widgetTemplates.comp.tsx");
